export default __webpack_public_path__ + "static/jack-b4212f506faa8c511603950b113981b2.png";